export const num = v => {
  const x = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(x) ? x : undefined;
};

export const roundToTwoDecimals = v => {
  const n = num(v);
  return n === undefined ? undefined : Math.round(n * 100) / 100;
};
